import React, { lazy, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import PageLoader from '../../@jumbo/components/PageComponents/PageLoader';

const Dashboards = ({ match }) => {
  const requestedUrl = match.url.replace(/\/$/, '');
  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        <Redirect exact from={`${requestedUrl}/`} to={`${requestedUrl}/product-kpi`} />
        <Route path={`${requestedUrl}/heatmap`} component={lazy(() => import('./HeatMap'))} />
        <Route path={`${requestedUrl}/product-kpi`} component={lazy(() => import('./Product'))} />
        <Route path={`${requestedUrl}/shipper-kpi`} component={lazy(() => import('./Shipper'))} />
        <Route path={`${requestedUrl}/carrier-kpi`} component={lazy(() => import('./Carrier'))} />
        {/* <Route path={`${requestedUrl}/crm`} component={lazy(() => import('./Crm'))} /> */}
        <Route path={`${requestedUrl}/tracking-kpi`} component={lazy(() => import('./TrackingDashboard'))} />
        <Route component={lazy(() => import('../Pages/404'))} />
      </Switch>
    </Suspense>
  );
};

export default Dashboards;
